import { isValid, format } from 'date-fns';
import { formatNumber, getAllDays, getAllMonths, getYears } from 'components/FormCreatorComponent/helpers';
import {
	fieldMode,
	fieldType,
	fieldsGroupType,
	createFormProps,
	dependencyAction,
	fieldDependencyType,
	customValueTypes,
	validationTypes,
} from 'components/FormCreatorComponent/types';
import { pendingRequestsTypes } from 'constants/requests.constants';
import BankAccountsDetails from 'sections/CustomerAccounts/BankAccounts/BankAccountsDetails';
import { getFile } from 'services/global.service';
import { timing } from 'constants/ui.constants';
import { ContactLegalStatus, generalTranslation } from 'constants/global.constants';
import { Box, Chip, Typography } from '@mui/material';
import _ from 'lodash';

const createFileField = (
	index: number,
	label: string,
	required: boolean = false,
	mode: fieldMode = fieldMode.readonly
) => ({
	type: fieldType.file,
	mode,
	props: {
		name: `files[${index}]`,
		label,
		required,
		disabled: true,
		onClick: (file: { key?: string; companyId?: number }) => {
			if (file?.key && file?.companyId) {
				getFile(file.key, file.companyId);
			}
		},
	},
	validation: required ? [{ requierd: true }] : undefined,
	dependencyAction: dependencyAction.hide,
	dependency: { name: `files[${index}]`, value: null, type: fieldDependencyType.isEmpty },
});

const createMultipleFileFields = (
	count: number,
	mode: fieldMode = fieldMode.readonly,
	firstFieldRequired: boolean = false
) => {
	return Array.from({ length: count }, (_, index) => {
		const label =
			index === 0
				? 'page.pendingRequests.field.fileReference'
				: `page.pendingRequests.field.fileReference${index + 1}`;
		const required = index === 0 ? firstFieldRequired : false;
		return createFileField(index, label, required, mode);
	});
};

export interface formConfig {
	[key: string]: createFormProps[];
}

export const pendingRequestsTypesForms: formConfig = {
	[pendingRequestsTypes.BALANCES]: [
		{
			name: 'page.pendingRequests.balance.field.requester',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'approvedBy.id',
								label: 'page.pendingRequests.balance.field.requester',
								options: [{ label: 'aaa', value: 'bbb' }],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.bankAccount',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.custom,
							props: {
								name: 'bankAccount.id',
								label: 'page.pendingRequests.balance.field.bankAccount.description',
								required: true,
								disabled: true,
								customComponent: BankAccountsDetails,
								customData: {
									accounts: [
										{
											id: 1,
											companyId: 1,
											accountOwnerName: 'Uzi Shalom',
											reference: 'iuiuiu',
											bankOrigin: 'aaaaaa',
											bankBranch: 'branch me',
											accountNumber: '426144',
											bankName: {
												bankName: 'eumi',
											},
											currencyId: 16,
										},
									],
									handleBankPick: () => {},
									selectedAccountId: null,
								},
							},
							validation: [{ custom: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.altshulerBankAccount',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.custom,
							mode: fieldMode.readonly,
							props: {
								name: 'altshulerAccountId',
								label: 'page.pendingRequests.balance.field.altshulerBankAccount.description',
								required: true,
								disabled: true,
								customComponent: BankAccountsDetails,
								customData: {
									accounts: [
										{
											id: 1,
											companyId: 1,
											accountOwnerName: 'Uzi Shalom',
											reference: 'iuiuiu',
											bankOrigin: 'aaaaaa',
											bankBranch: 'branch me',
											accountNumber: '426144',
											bankName: {
												bankName: 'eumi',
											},
											currencyId: 16,
										},
									],
									handleBankPick: () => {},
									selectedAccountId: null,
								},
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								label: 'page.pendingRequests.balance.field.createdAt',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
						},

						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'currency.id',
								label: 'page.pendingRequests.balance.field.currency',
								options: [],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'amount',
								label: 'page.pendingRequests.balance.field.amount',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }, { integer: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.file,
							mode: fieldMode.readonly,
							props: {
								name: 'file',
								label: 'page.pendingRequests.field.fileReference',
								required: true,
								disabled: true,
								onClick: (file) => {
									getFile(file?.key, file?.companyId);
								},
							},
							validation: [{ requierd: true }],
							dependencyAction: dependencyAction.hide,
							dependency: {
								name: 'file',
								value: null,
								type: fieldDependencyType.isEmpty,
							},
						},
						// {
						// 	type: fieldType.checkbox,
						// 	props: {
						// 		name: 'houseAccountTransferCheck',
						// 		label: 'page.pendingRequests.balance.field.houseAccountTransfer',
						// 		required: false,
						// 	},
						// 	validation: [{}],
						// },
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'houseAccountTransferReference',
								label: 'page.pendingRequests.balance.field.reference',
								required: false,
								disabled: false,
							},
							// dependency: { name: 'houseAccountTransferCheck', value: 'true' },
							// dependencyAction: dependencyAction.disable,
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.companyManagement',
			hide: true,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.manager.name',
								label: 'page.pendingRequests.balance.field.requester.company.manager',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.firstBoSigner',
			hide: true,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.checkbox,
							props: {
								name: 'approveTitle',
								label: 'page.pendingRequests.balance.field.confirm.title',
								required: false,
								disabled: false,
							},
							validation: [{ checked: true }],
						},
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'approveSubTitle',
								label: 'page.pendingRequests.balance.field.confirm.subtitle',
								required: false,
								disabled: false,
							},
							validation: [],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.CONTACTS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameHebrew',
								label: 'label.firstName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameHebrew',
								label: 'label.lastName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstName',
								label: 'label.firstNameEnglish',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastName',
								label: 'label.lastNameEnglish',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'label.birthDate',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'day',
								label: 'label.day',
								options: getAllDays(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'month',
								label: 'label.month',
								options: getAllMonths(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'year',
								label: 'label.year',
								options: getYears(),
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'legalStatus',
								label: 'label.publicFigure',
								options: [
									{ value: ContactLegalStatus.Legal, label: 'label.yes', disabled: true },
									{ value: ContactLegalStatus.NotLegal, label: 'label.no', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
								options: [
									{ value: 'ID', label: 'label.identicationId', disabled: true },
									{ value: 'Passport', label: 'label.Passport', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				/*
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'gender',
								label: 'label.gender',
								options: [
									{ value: 'Male', label: 'label.male', disabled: true },
									{ value: 'Female', label: 'label.female', disabled: true },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				*/
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'email',
								label: 'label.email',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }, { email: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phone',
								label: 'label.phone',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }, { phone: true }],
						},
						/*
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: 'label.country',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						*/
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'occupation',
								label: 'label.role',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'permission',
								label: 'label.permisionLevel',
								options: [
									{ label: 'Signer', value: 'Signer' },
									{ label: 'Operationer', value: 'Operationer' },
									{ label: 'Viewer', value: 'Viewer' },
								],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true, integer: true }],
							suffix: '$',
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true, integer: true }],
							suffix: '$',
							customValueType: customValueTypes.integer,
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.BANK_ACCOUNTS]: [
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountOwnerName',
								label: 'page.pendingRequests.field.accountOwnerName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'bankName.bankCode',
								label: 'page.pendingRequests.field.bankName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankBranch',
								label: 'page.pendingRequests.field.bankBranch',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountNumber',
								label: 'page.pendingRequests.field.accountNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.approveAccount',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.file,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'file',
								label: 'page.pendingRequests.field.fileReference',
								required: true,
								disabled: true,
								onClick: (file) => {
									getFile(file?.key, file?.companyId);
								},
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.BENEFICIARIES]: [
		{
			name: 'page.managePendingRequests.forms.beneficiaryDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'type',
								label: 'label.beneficiaryType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'firstName',
								label: 'label.firstName',
								disabled: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'lastName',
								label: 'label.lastName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'companyName',
								label: 'label.companyName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'type', value: 'Company' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'nickname',
								label: 'label.nickname',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'identificationNumber',
								label: 'label.identificationNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'address',
								label: 'label.address',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'city',
								label: 'label.city',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'country.name',
								label: 'label.country',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'website',
								label: 'label.website',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: { name: 'website', value: null, type: fieldDependencyType.isEmpty },
						},
						{
							type: fieldType.radio,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'countryAtRiskDuringCreation',
								label: 'page.pendingRequests.field.countryAtRiskDuringCreation',
								required: false,
								disabled: true,
								options: [
									{ value: 'true', label: 'label.yes', disabled: true },
									{ value: 'false', label: 'label.no', disabled: true },
								],
							},
						},
						{
							type: fieldType.radio,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'country.isTaxShelter',
								label: 'page.pendingRequests.field.countryIsTaxShelter',
								required: false,
								disabled: true,
								options: [
									{ value: 'true', label: 'label.yes', disabled: true },
									{ value: 'false', label: 'label.no', disabled: true },
								],
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'note',
								label: 'page.customerAccounts.forms.beneficiaries.beneficiaryDetails.note',
								required: true,
								disabled: true,
							},
							dependency: { name: 'note', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.file,
							mode: fieldMode.readonly,
							props: {
								name: 'formalBankApproveFile',
								label: 'page.pendingRequests.field.formalBankApproveFile',
								disabled: true,
								onClick: (formalBankApproveFile: any) => {
									getFile(formalBankApproveFile?.key, formalBankApproveFile?.companyId);
								},
							},
							dependency: {
								name: 'formalBankApproveFile',
								value: null,
								type: fieldDependencyType.isEmpty,
							},
						},
						...createMultipleFileFields(6, fieldMode.readWithEnableWrite, false),
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'comment',
								label: 'page.pendingRequests.field.comment',
								required: true,
								disabled: true,
							},
							dependency: { name: 'comment', value: null, type: fieldDependencyType.isEmpty },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'hasWcIndications',
								label: 'label.hasWcIndications',
								required: false,
								disabled: true,
								options: [
									{ value: 'true', label: 'label.yes', disabled: true },
									{ value: 'false', label: 'label.no', disabled: true },
								],
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'wcCaseId',
								label: 'label.wcCaseId',
								required: false,
								disabled: true,
							},
							dependency: { name: 'hasWcIndications', value: 'true' },
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.bank',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankAccountHolderName',
								label: 'label.bankAccountHolderName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'accountNumber',
								label: 'label.accountNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'accountNumber', value: '.+' },
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankAccountCountry.name',
								label: 'label.bankAccountCountry',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'commentForUnequalCountries',
								label: 'label.commentForUnequalCountries',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: false }],
							dependency: {
								name: 'commentForUnequalCountries',
								value: null,
								type: fieldDependencyType.isEmpty,
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'postcode',
								label: 'label.postalCode',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'postcode', value: '.+' },
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'stateOrProvince',
								label: 'label.stateOrProvince',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'stateOrProvince', value: '.+' },
						},
						{
							type: fieldType.select,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'currencyId',
								label: 'label.currency',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'paymentType',
								label: 'label.paymentType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValue: (value: string) =>
								value?.includes('/')
									? `${generalTranslation.Regular}/${generalTranslation.Priority}`
									: generalTranslation[value],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bicSwift',
								label: 'BIC/SWIFT',
								required: true,
								disabled: true,
							},
							dependency: { name: 'bicSwift', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'iban',
								label: 'IBAN',
								required: true,
								disabled: true,
							},
							dependency: { name: 'iban', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'aba',
								label: 'ABA',
								required: true,
								disabled: true,
							},
							dependency: { name: 'aba', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankCode',
								label: 'Bank Code',
								required: true,
								disabled: true,
							},
							dependency: { name: 'bankCode', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'sortCode',
								label: 'Sort Code',
								required: true,
								disabled: true,
							},
							dependency: { name: 'sortCode', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bsbCode',
								label: 'BSB Code',
								required: true,
								disabled: true,
							},
							dependency: { name: 'bsbCode', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'branchCode',
								label: 'Branch Code',
								required: true,
								disabled: true,
							},
							dependency: { name: 'branchCode', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'clabe',
								label: 'Clabe',
								required: true,
								disabled: true,
							},
							dependency: { name: 'clabe', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'cnaps',
								label: 'Cnaps',
								required: true,
								disabled: true,
							},
							dependency: { name: 'cnaps', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'ifsc',
								label: 'Ifsc',
								required: true,
								disabled: true,
							},
							dependency: { name: 'ifsc', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.radio,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankAccountCountry.isRisky',
								label: 'page.pendingRequests.field.bankCountryAtRisk',
								required: false,
								disabled: true,
								options: [
									{ value: 'true', label: 'label.yes', disabled: true },
									{ value: 'false', label: 'label.no', disabled: true },
								],
							},
						},
						{
							type: fieldType.radio,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'bankAccountCountry.isTaxShelter',
								label: 'page.pendingRequests.field.bankCountryIsTaxShelter',
								required: false,
								disabled: true,
								options: [
									{ value: 'true', label: 'label.yes', disabled: true },
									{ value: 'false', label: 'label.no', disabled: true },
								],
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiaryDeniedMessages',
								label: 'page.customerAccounts.forms.beneficiaries.lastDeniedMessages.title',
								disabled: true,
							},
							dependency: {
								name: 'beneficiaryDeniedMessages',
								value: null,
								type: fieldDependencyType.isCustomDependency,
								custom: (record) => {
									const lastRelevantRecord = _.findLast(
										record?.beneficiaryDeniedMessages,
										'createdByContactId'
									);
									return (
										_.isEmpty(record) ||
										_.isEmpty(record?.beneficiaryDeniedMessages) ||
										lastRelevantRecord?.message === null
									);
								},
							},
							customValue: (value: any) => {
								try {
									const msg = _.findLast(value, (record) => record.createdByContactId);
									return msg ? msg.message : '';
								} catch (e) {
									return '';
								}
							},
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'createdBy.fullName',
								label: 'page.customerAccounts.forms.payment.details.createdBy',
								required: true,
								disabled: true,
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'approvedByContactId.fullName',
								label: 'page.customerAccounts.forms.payment.details.approvedByContact',
								required: false,
								disabled: true,
							},
							dependency: { name: 'approvedByContactId.fullName', value: '.+' },
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.GENERAL_SUPPORT]: [
		{
			name: 'page.managePendingRequests.forms.support',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'subject',
								label: 'label.subjectOfSupport',
								options: [
									{ label: 'label.techSupport', value: 'Website technical support' },
									{ label: 'label.illegalActivity', value: 'Report a suspicious behavior' },
									{ label: 'label.wrongNumbers', value: 'Found an error in my account' },
								],
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.textArea,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'message',
								label: 'label.contentOfSupport',
								disabled: true,
							},
							dependency: { name: 'beneficiary.type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: [
		{
			name: 'page.pendingRequests.balance.field.requester',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'createdBy.fullName',
								label: 'page.customerAccounts.forms.payment.details.createdBy',
								required: true,
								disabled: true,
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'approvedByContactId.fullName',
								label: 'page.customerAccounts.forms.payment.details.approvedByContact',
								required: false,
								disabled: true,
							},
							dependency: { name: 'approvedByContactId.fullName', value: '.+' },
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.transferDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'createdAt',
								label: 'page.pendingRequests.balance.field.createdAt',
								required: false,
								disabled: false,
							},
							validation: [{ requierd: false }],
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'currency',
								label: 'page.pendingRequests.balance.field.currency',
								options: [],
								required: true,
								disabled: false,
							},
							renderOption: (props, option) => {
								return (
									<Box
										component="li"
										{...props}
										className=""
										sx={{
											padding: '8px 16px',
											display: 'flex',
											justifyContent: 'space-between',
										}}
									>
										<Typography>{option.label}</Typography>
										<Chip
											size="small"
											label={`${option?.currency?.symbol}${formatNumber(option.amount)}`}
										/>
									</Box>
								);
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'amount',
								label: 'page.pendingRequests.balance.field.amount',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.exceedsBalance]: 0 }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'message',
								label: 'page.pendingRequests.balance.field.message',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'companyBankAccountId',
								options: [],
								label: 'page.pendingRequests.balance.field.accountForWithdrawal',
								required: true,
								disabled: false,
							},
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.companyManagement',
			hide: true,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'company.manager.name',
								label: 'page.pendingRequests.balance.field.requester.company.manager',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.firstBoSigner',
			hide: true,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boFirstBoSignerApprovedByUserName',
								label: 'page.pendingRequests.balance.field.bo.signer.approval.name',
								required: false,
								disabled: true,
							},
							validation: [{}],
						},
					],
				},
			],
		},
		{
			name: 'page.pendingRequests.balance.field.confirm.mainTitle',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.checkbox,
							props: {
								name: 'approveTitle',
								label: 'page.pendingRequests.balance.field.confirm.title',
								required: false,
								disabled: false,
							},
							validation: [{ checked: true }],
						},
						{
							type: fieldType.label,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'approveSubTitle',
								label: 'page.pendingRequests.balance.field.confirm.subtitle',
								required: false,
								disabled: false,
							},
							validation: [],
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.PAYMENTS]: [
		{
			name: 'page.managePendingRequests.forms.transactionDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'createdAt',
								label: 'page.customerAccounts.forms.payment.details.createdAt',
								required: true,
								disabled: true,
							},
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
							validation: [{ requierd: true }],
							suffix: '',
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'updatedAt',
								label: 'page.customerAccounts.forms.payment.details.updatedAt',
								required: true,
								disabled: true,
							},
							dependency: { name: 'status', value: 'Completed' },
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
							validation: [{ requierd: true }],
							suffix: '',
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'dueDate',
								label: 'page.customerAccounts.forms.payment.details.dueDate',
								required: true,
								disabled: true,
							},
							customValue: (value: any) =>
								isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value,
							validation: [{ requierd: true }],
							suffix: '',
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'reference',
								label: 'label.referenceNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'amount',
								label: 'label.amount',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
							suffix: '',
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'currency.name',
								label: 'label.currency',
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'type',
								label: 'label.paymentType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'fee.swiftFeeType',
								label: 'page.customerAccounts.forms.payment.details.feeType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.bicSwift',
								label: 'page.customerAccounts.forms.payment.details.swiftNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'fee.amount',
								label: 'page.customerAccounts.forms.payment.details.fee',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
						// {// this field is not used in the pending requests - decided to remove it
						// 	type: fieldType.text,
						// 	mode: fieldMode.readWithEnableWrite,
						// 	props: {
						// 		name: 'reasonTitle',
						// 		label: 'page.customerAccounts.forms.payment.details.reasonTitleType',
						// 		required: true,
						// 		disabled: true,
						// 	},
						// 	validation: [{ requierd: true }],
						// },
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'paymentCategoryDisplay',
								label: 'page.customerAccounts.forms.payment.category.title',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'purposeCode',
								label: 'page.customerAccounts.forms.payment.details.purposeCode',
								required: false,
								disabled: true,
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'paymentComment',
								label: 'page.customerAccounts.forms.payment.details.paymentComment',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'complianceReference',
								label: 'page.customerAccounts.forms.payment.details.complianceReference',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'invoiceNumber',
								label: 'page.customerAccounts.forms.payment.details.invoiceNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},

						...createMultipleFileFields(5, fieldMode.readWithEnableWrite, true),
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.beneficiaryDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.type',
								label: 'label.beneficiaryType',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.firstName',
								label: 'label.firstName',
								disabled: true,
							},
							dependency: { name: 'beneficiary.type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.lastName',
								label: 'label.lastName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'beneficiary.type', value: 'Individual' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.companyName',
								label: 'label.companyName',
								required: true,
								disabled: true,
							},
							dependency: { name: 'beneficiary.type', value: 'Company' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.nickname',
								label: 'label.nickname',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.country.name',
								label: 'label.country',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.bankAccountHolderName',
								label: 'label.bankAccountHolderName',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.accountNumber',
								label: 'label.accountNumber',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'beneficiary.accountNumber', value: '.+' },
						},
						{
							type: fieldType.select,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.bankAccountCountryId',
								label: 'label.bankAccountCountry',
								required: true,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.bicSwift',
								label: 'BIC/SWIFT',
								required: true,
								disabled: true,
							},
							dependency: { name: 'beneficiary.bicSwift', value: '.+' },
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'beneficiary.iban',
								label: 'IBAN',
								required: true,
								disabled: true,
							},
							dependency: { name: 'beneficiary.iban', value: '.+' },
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readWithEnableWrite,
							props: {
								name: 'createdBy.fullName',
								label: 'page.customerAccounts.forms.payment.details.createdBy',
								required: true,
								disabled: true,
							},
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'signedByContact.fullName',
								label: 'page.customerAccounts.forms.payment.details.approvedByContact',
								required: false,
								disabled: true,
							},
						},
					],
				},
			],
		},
	],
	[pendingRequestsTypes.REFUNDS]: [
		{
			name: 'page.managePendingRequests.forms.refund',
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'currencyId',
								label: 'page.customerAccounts.forms.balance_refund.currency',
								options: [{ label: 'aaa', value: 'bbb' }],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'amount',
								label: 'page.customerAccounts.forms.balance_refund.amount',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }, { [validationTypes.integer]: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'boNotes',
								label: 'page.customerAccounts.forms.balance_refund.reason',
								options: [{ label: 'aaa', value: 'bbb' }],
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
};
